import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import Swal from "sweetalert2";
import MainHelper, {apiCall} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
class IncomeNotificationHistoryTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleDelete = async (notifyId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/notifications/app/delete/'+notifyId,'delete',null);
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Bildirim başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }

    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasDeleteNotificationHistory = userPermissions.includes('delete notification history');
        const getTypeName = (type) => {
            switch (type) {
                case 'receivable':
                    return 'Alacak ve Ödemeler';
                case 'offer':
                    return 'Teklif';
                case 'servicezone':
                    return 'Servicezone';
                case 'custom':
                    return 'Özel';
                case 'einbox_confirmed':
                    return 'Fatura';
                case 'einbox_error':
                    return 'Fatura';
                default:
                    return 'Bilinmiyor';
            }
        };
        const columns = [
            {
                name:'ID',
                selector:row => row.id,
                sortable:true
            },
            {
                name:'Başlık',
                selector:row => row.title,
                sortable:true
            },

            {
                name:'İçerik',
                selector:row => row.message

            },

            {
                name:'İçerik Tipi',
                selector:row => getTypeName(row.type)

            },
            {
                name:'Durum',
                selector:row => row.is_read === 1 ? "Okundu" : "Okunmadı"

            },
            {
                name:'Tarih',
                selector:row => MainHelper.dateFormat(row.created_at)

            },

            {
                name: 'İşlem',
                button: true,
                cell: row => (
                    <>
                        {userHasDeleteNotificationHistory ? (
                            <IconButton className="btn btn-outline-secondary" onClick={() => this.handleDelete(row.id)} style={{cursor: 'pointer',marginLeft:-15}}>
                                <button type="button" className="btn btn-outline-danger btn-sm" ><i className="icon-trash"></i></button>
                            </IconButton>
                        ):""}
                    </>
                )}

        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/notifications/app/get-history"}
                columns={columns}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(IncomeNotificationHistoryTable));
